import React, { useEffect, useState } from "react";
import InsightTable from "../InsightTable";
import { transformResultsToTableData } from "../../../../services/commonService";
import { useParams } from "react-router-dom";

function FeaturesDifferentiators({ featuresAndDifferentiators }) {
  const [tabData, setTabData] = useState([]);
  const { clientName, competitorName } = useParams();
  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    { type: "conversation", title: "Conversation", onClick: () => {} },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  // const dummyData = [
  //   {
  //     competitor: "a",
  //     key_features: "b",
  //     unique_selling_proposition: "c",
  //     regulatory_compliance: "d",
  //     key_features_positive_insight: "b",
  //     key_features_negative_insight: "b",
  //     key_features_recent_development: "b",
  //     unique_selling_proposition_positive_insight: "c",
  //     unique_selling_proposition_negative_insight: "c",
  //     unique_selling_proposition_recent_development: "c",
  //     regulatory_compliance_positive_insight: "d",
  //     regulatory_compliance_negative_insight: "d",
  //     regulatory_compliance_recent_development: "d",
  //   },
  //   {
  //     competitor: "a",
  //     key_features: "b",
  //     unique_selling_proposition: "c",
  //     regulatory_compliance: "d",
  //     key_features_positive_insight: "b",
  //     key_features_negative_insight: "b",
  //     key_features_recent_development: "b",
  //     unique_selling_proposition_positive_insight: "c",
  //     unique_selling_proposition_negative_insight: "c",
  //     unique_selling_proposition_recent_development: "c",
  //     regulatory_compliance_positive_insight: "d",
  //     regulatory_compliance_negative_insight: "d",
  //     regulatory_compliance_recent_development: "d",
  //   },
  //   {
  //     competitor: "a",
  //     key_features: "b",
  //     unique_selling_proposition: "c",
  //     regulatory_compliance: "d",
  //     key_features_positive_insight: "b",
  //     key_features_negative_insight: "b",
  //     key_features_recent_development: "b",
  //     unique_selling_proposition_positive_insight: "c",
  //     unique_selling_proposition_negative_insight: "c",
  //     unique_selling_proposition_recent_development: "c",
  //     regulatory_compliance_positive_insight: "d",
  //     regulatory_compliance_negative_insight: "d",
  //     regulatory_compliance_recent_development: "d",
  //   },
  // ];

  useEffect(() => {
    const tableData = transformResultsToTableData(featuresAndDifferentiators);
    setTabData(tableData);
  }, [featuresAndDifferentiators]);

  const tableColumns = [
    // { id: "competitor", label: "Competitor" },
    { key: "key_features", label: "Key Features" },
    { key: "unique_selling_proposition", label: "Unique Selling Proposition" },
    { key: "regulatory_compliance", label: "Regulatory Compliance" },
  ];

  return (
    <InsightTable
      title="Features & Differentiators"
      subtitle={`A comparative review of the product capabilities, compliance credentials, and market-facing differentiation strategies across ${
        clientName ?? "HB Fuller"
      }, ${competitorName ?? "Tailored Chemical Products"}, and ${
        competitorName ?? "Tailored Chemical Products"
      }.`}
      data={tabData}
      metrics={tableColumns}
      rowIdentifier="competitor"
      actions={actions}
    />
  );
}

export default FeaturesDifferentiators;
